import { useEffect, useState } from "react";
import { IpApiResponse } from "./useUserData.model";
import { CountryCode } from "libphonenumber-js/types.cjs";

const useUserData = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [data, setData] = useState<IpApiResponse | undefined | null>(undefined);
  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const res = await fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=1ea0e4a213b345ba8d430057fde8980b", {
          method: "GET",
        });

        if (!res.ok) {
          throw new Error("Error al obtener metadata");
        }

        const data: IpApiResponse = await res.json();
        setData(data);
        setIsSuccess(true);
      } catch (err) {
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMetadata();
  }, []);

  return {
    countryCode: data?.country.iso_code ?? "",
    ipAddress: "",
    isLoading,
    isSuccess,
  };
};

export { useUserData };
